import { useState } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const { settings } = useSettings();
  const cols = settings.footer?.columns || [];
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/newsletter", { email, consent: true });
      toast.success(data.message || "Ingeschreven");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <footer className="bg-[#1D1D1B] text-[#F7F5F1] mt-24" data-testid="site-footer">
      <div className="onusa-container py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <p className="font-display text-2xl tracking-[0.42em] font-semibold">ONUSA</p>
            <p className="label-x mt-4 text-[#F7F5F1]/60">EST 2026 — PROTOCOL</p>
            <p className="mt-6 text-sm text-[#F7F5F1]/70 max-w-xs leading-relaxed">
              Discipline creates freedom. Meer dan kleding — een Europees contemporary streetwear-huis.
            </p>
            <form onSubmit={subscribe} className="mt-8 flex items-center border-b border-[#F7F5F1]/30 max-w-xs">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-MAIL"                className="flex-1 bg-transparent py-2 outline-none font-mono text-xs tracking-[0.18em] placeholder:text-[#F7F5F1]/40"
                data-testid="newsletter-input"
              />
              <button type="submit" className="font-mono text-xs tracking-[0.2em] py-2" data-testid="newsletter-submit">AANMELDEN →</button>
            </form>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <p className="label-x text-[#F7F5F1]/60">{c.title}</p>
              <ul className="mt-5 space-y-3">
                {c.links.map((l) => (
                  <li key={l.href}>
                    <Link to={l.href} className="text-sm text-[#F7F5F1]/80 hover:text-[#F7F5F1] transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="rule-x border-[#F7F5F1]/15 mt-14 pt-6 flex flex-col md:flex-row justify-between gap-3">
          <p className="label-x text-[#F7F5F1]/50">© {new Date().getFullYear()} ONUSA. ALLE RECHTEN VOORBEHOUDEN.</p>
          <div className="flex gap-6">
            {settings.socials?.instagram && <a href={settings.socials.instagram} target="_blank" rel="noreferrer" className="label-x text-[#F7F5F1]/60 hover:text-[#F7F5F1]">INSTAGRAM</a>}
            {settings.socials?.tiktok && <a href={settings.socials.tiktok} target="_blank" rel="noreferrer" className="label-x text-[#F7F5F1]/60 hover:text-[#F7F5F1]">TIKTOK</a>}
          </div>
        </div>
      </div>
    </footer>
  );
}
